import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { renderIdentifierGeneric } from "../RenderIdentifier";
import ThemeProvider from "../theme";
import { Container, RowStyle } from "../theme/common";
import { HeadingSection } from "../theme/components/HeadingSection";
import { SPACING } from "../theme/palette";
import { DNBAccordion } from "./Accordian";
import { DNBTabs } from "./Tabs";
const ContainerStyle = styled("div")(({ theme }) => ({
    "backgroundColor": theme.palette.background.paper,
    "paddingBlock": SPACING.space2xl,
}));
const HeadingSectionContainerStyle = styled("div")(() => ({
    "margin": " 0px auto",
    "maxInlineSize": " calc(77rem * .65)",
}));
const RowStyleOverride = styled(RowStyle)(({ theme }) => ({
    "color": theme.palette.common.white,
}));
const ProductTabbedContainerComponent = (props) => {
    const { productTabbedContainerHeading, productTabbedContainerSubHeading, productTabs } = props;
    const [filteredTabs, setFilteredTabs] = useState([]);
    useEffect(() => {
        const filTabs = productTabs.filter((ele) => ele.tabTitle);
        setFilteredTabs(filTabs);
    }, [productTabs]);
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    return (_jsx(ThemeProvider, { children: _jsx(ContainerStyle, { children: _jsxs(Container, { children: [_jsx(HeadingSectionContainerStyle, { children: _jsx(HeadingSection, { sectionHeading: productTabbedContainerHeading, sectionSubHeading: productTabbedContainerSubHeading }) }), _jsx(RowStyleOverride, { children: matches ? (_jsx(DNBTabs, { tabs: filteredTabs })) : (_jsx(DNBAccordion, { tabs: filteredTabs })) })] }) }) }));
};
const productTabbedContainer = (renderableData) => renderIdentifierGeneric(ProductTabbedContainerComponent, renderableData);
export { productTabbedContainer };
